import React from 'react'
import { View } from 'react-native'
import { Header, Screen, SearchBar } from '@components'
import { useRoute, useTheme } from '@react-navigation/native'
import { useLanguage } from '@context'
import { ContactsList, AddContactModal } from './components'
import { useAddContacts, useContactFiltering } from './hooks'
import { getListingContactsStyles } from '../listingContacts'
import { AddContactsProps } from './types'
import { ContactFilters, ListingContactsFilters } from '../listingContacts'
import { useScreen } from '@hooks'
import { getCommonStyles } from '@utils'

export const AddContacts: React.FC<AddContactsProps> = ({ navigation }) => {
  const { t } = useLanguage()
  const route = useRoute()
  const theme = useTheme()
  const styles = getListingContactsStyles(theme)
  const {isDesktop, isMobile} = useScreen()
  const commonStyles = getCommonStyles(theme)

  // Utiliser le hook principal
  const {
    selectedContact,
    pendingRequestAccountIds,
    isAddContactModalVisible,
    setIsAddContactModalVisible,
    handleAddContact,
    handleAddPrivate,
    handleAddProfessional,
    handleFilterPress,
  } = useAddContacts(navigation)

  const {contacts, isPending, isFetchingNextPage, hasNextPage, fetchNextPage, searchText, setSearchText, getActiveFiltersCount, hasActiveFilters} = useContactFiltering()
  
  return (
    <Screen>
      <View style={!isMobile? styles.containerList : commonStyles.flex}>
        <View style={[commonStyles.flex, commonStyles.fullHeight]}>
          <Header
            title={t('form.addContact')}
            iconLeft="arrowBack"
            iconColor={theme.colors.secondary}
            onPressLeft={() => navigation.navigate('Tab')}
          />

          <View style={isDesktop && styles.containerSearch}>
            <View style={[styles.container, !isDesktop && commonStyles.paddingBottom]}>
              <SearchBar 
                value={searchText}
                onChangeText={setSearchText}
              />
            </View>

            {/* Filtres de contacts */}
            <ContactFilters
              noScope
              onFilterPress={isMobile? handleFilterPress : () => {}}
              activeFiltersCount={getActiveFiltersCount()}
              hasActiveFilters={hasActiveFilters()}
            />
          </View>
          <ContactsList
            contacts={contacts || []}
            isLoading={isPending}
            isFetchingNextPage={isFetchingNextPage}
            hasNextPage={hasNextPage}
            fetchNextPage={fetchNextPage}
            emptyMessage={t('addContact.emptyData') || 'Aucun contact trouvé'}
            onContactPress={(contact) => (navigation as any).navigate('Profile', {
              screen: 'DetailsGhostProfile',
              params: { profileId: contact.id }
            })}
            onAddPress={handleAddContact}
            pendingRequestAccountIds={pendingRequestAccountIds}
          />
        </View>
        {!isMobile && <ListingContactsFilters navigation={navigation as any} route={{ ...(route as any), params: { ...(route as any)?.params, isSuggested: true } } as any} />}
      </View>

      <AddContactModal
        isVisible={isAddContactModalVisible}
        setIsVisible={(visible) => setIsAddContactModalVisible(typeof visible === 'function' ? visible(isAddContactModalVisible) : visible)}
        contactName={selectedContact?.fullName || ''}
        onAddPrivate={handleAddPrivate}
        onAddProfessional={handleAddProfessional}
      />
    </Screen>
  )
} 